import React, { useState, useEffect } from "react";
import {
	Modal,
	ModalBody,
	ModalHeader,
	ModalFooter,
	Spinner,
} from "reactstrap";
import {
	returnBookingService,
} from "../../../../../../services";


const QueryModal = (props) => {
	const [loading, setLoading] = useState(false);
	const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
	const [queryComment, setQueryComment] = useState("");
	const [queryError, setQueryError] = useState("");
	const modalClose = (flag) => {
		setQueryComment("");
		setQueryError("");
		props.queryModalClose(flag);
	};


	const handleDoQuery = async () => {

		if (!queryComment.trim()) {
			setQueryError("Please enter query comment");
			return;
		  }
		  else
		  {
			setQueryError("");
		  }
		

		setLoading(true);

		const params = {
			bookingId: props.bookingId,
			log_by_id: user.data._id,
			query_comment: queryComment
		};

		try {
			let response;
			
			response = await returnBookingService.doReturnQuery(params);
			


			console.log("API response:", response);
			modalClose(true);
		} catch (error) {
			console.error("API call failed:", error);
		} finally {
			setLoading(false);
		}
	};


	useEffect(() => {
		setUser(JSON.parse(localStorage.getItem("user")));
	}, []);

	return (
		<Modal
			size="md"
			backdrop="static"
			centered 
			isOpen={props.queryModal}
			toggle={() => modalClose(false)}
		>
			<ModalHeader className="" toggle={() => modalClose(false)}>

			Query?
			</ModalHeader>
			<ModalBody>
				
				<div className="form-group ">
					<label>Write your query</label>
					<textarea
					className="form-control"
					rows="4"
					placeholder="Enter your query..."
					value={queryComment}
					onChange={(e) => setQueryComment(e.target.value)}
					/>
					<div className="text-danger">{queryError}</div>
				</div>
				</ModalBody>
			<ModalFooter>
				<div className="">
					<button
						onClick={() => modalClose(false)}
						className="btn btn-secondary mr-2"
						data-dismiss="modal"
					>
						Cancel
					</button>
					{!loading && (
						<button
							className="btn btn-primary"
							onClick={handleDoQuery}
						>
							Ok
						</button>
					)}
					{loading && (
						<button
							className="btn btn-primary loader-icon"
							disabled
						>
							<Spinner className="img-svg"></Spinner>
						</button>
					)}
				</div>
			</ModalFooter>
		</Modal>
	);
};

export default QueryModal;
